import { IServerConnectionLogger } from '../types';
import { injectable, inject } from 'inversify';
import { SERVICE_IDENTIFIERS } from '@/app-modules/_ioc/service-identifiers';
import { IPersistedStore } from '@/app-modules/store/persisted-store';
import { UserPreferences } from '@/app-modules/store/modules/user-preferences';
import { IEventBusService } from '@/app-modules/event-bus/event-bus-service';
import { UserSettingsUpdatedEventName } from '@/components/user-settings/_domain/models/events';
import { IErrorService } from '@/app-modules/error';
import { User } from '@/app-modules/store/modules/user';

@injectable()
export class ServerConnectionLogger implements IServerConnectionLogger {
    private loggingEnabled: boolean = false;

    constructor(
        @inject(SERVICE_IDENTIFIERS.IPersistedStore) private readonly store: IPersistedStore,
        @inject(SERVICE_IDENTIFIERS.IEventBusService) private readonly eventBusService: IEventBusService,
        @inject(SERVICE_IDENTIFIERS.IErrorService) private readonly errorService: IErrorService
    ) {
        this.refreshLoggingState();
        this.eventBusService.getEventBus().$on(UserSettingsUpdatedEventName, () => this.refreshLoggingState());
    }

    public log(message: any, data?: any): void {
        if (this.loggingEnabled) {
            console.log(message, data);

            data = Object.assign(data || {}, { username: this.getCurrentUser() });
            this.errorService.logInfo(message, data);
        }
    }

    public debug(message: any, data?: any): void {
        if (this.loggingEnabled) {
            console.log(message, data);
        }
    }

    public error(message: any, data?: any): void {
        if (this.loggingEnabled) {
            console.error(message, data);

            data = Object.assign(data || {}, { username: this.getCurrentUser() });
            this.errorService.logError(new Error(message), data);
        }
    }

    private refreshLoggingState() {
        this.loggingEnabled = this.isLoggingEnabled();
    }

    private isLoggingEnabled(): boolean {
        const preferences = this.getUserPreferences();
        return preferences && preferences.logWebSocketActivity;
    }

    private getCurrentUser(): string | undefined {
        const user = this.store.Get(User);
        return user ? user.username : undefined;
    }

    private getUserPreferences(): UserPreferences {
        return this.store.Get(UserPreferences);
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/app-modules/server-communications/utilities/server-connection-logger.ts